export default __webpack_public_path__ + "static/media/Mexican.d4ffadc4.png";